import { type ParseStats } from '../core/models'

export class StatusBar {
  constructor(private el: HTMLElement) {}

  ready(): void {
    this.el.textContent = 'Ready.'
  }

  converting(): void {
    this.el.textContent = 'Converting...'
  }

  done(stats: ParseStats): void {
    if (stats.errors === 0) {
      this.el.textContent = `Done. Success: ${stats.success} / ${stats.total}`
    } else if (stats.success === 0) {
      this.el.textContent = `Done with errors. Success: 0 / ${stats.total}`
    } else {
      this.el.textContent = `Done. Success: ${stats.success} / ${stats.total} (${stats.errors} errors)`
    }
  }

  error(message: string): void {
    this.el.textContent = `Error: ${message}`
  }
}
